import React from "react";
import Text from "@amzn/meridian/text";
import { FormattedMessage } from "react-intl";
import Column from "@amzn/meridian/column";

function headerContent() {
  return (
    <Column spacing="none">
      <Text type="h400">
        <FormattedMessage
          id="verificationOptions.header.verify"
          defaultMessage="Dolphin Verification"
        />
      </Text>
      <Text color="secondary">
        <FormattedMessage
          id="verificationOptions.text.inputPageHeader"
          defaultMessage="Problem Solve module requires additional verification. Generate verification code for associates working in those process paths. Use one of the options provided below."
        />
      </Text>
    </Column>
  );
}

export default headerContent;



// WEBPACK FOOTER //
// ./src/components/dolphinVerification/headerContent/HeaderContent.js